const ShopArticleComponent = () => import('@/views/shop/ShopArticle/ShopArticleView')

export default [
    {
        path:'/ShopArticleIndex',
        name:'ShopArticleRouter',
        component:ShopArticleComponent
    }
]